import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Tasks } from './pages/Tasks';
import { Chat } from './pages/Chat';
import { Reports } from './pages/Reports';
import { WhatsApp } from './pages/WhatsApp';
import { Emails } from './pages/Emails';
import { HR } from './pages/HR';
import { HRFerie } from './pages/HRFerie';
import { BustePaga } from './pages/BustePaga';
import { Statistics } from './pages/Statistics';
import { Settings } from './pages/Settings';
import { GestioneUtenti } from './pages/GestioneUtenti';
import { Preventivi } from './pages/Preventivi';
import { HRCUD } from './pages/HRCUD';
import { Calendario } from './pages/Calendario';
import FinanziaPolizza from './pages/FinanziaPolizza';
import Scadenze from './pages/Scadenze';
import Consulenze from './pages/CrossSell';
import GaranzieComparatore from './pages/GaranzieComparatore';
import { PreventivatoreAuto } from './pages/PreventivatoreAuto';
import { EstensionePage } from './pages/EstensionePage';
import PrenotaPubblica from './pages/PrenotaPubblica';
import PrenotaConferma from './pages/PrenotaConferma';
import { NoteAI } from './pages/NoteAI';
import Prestiti from './pages/Prestiti';
import Leads from './pages/Leads';
import Sinistri from './pages/Sinistri';
import { Clients } from './pages/Clients';
import RichiesteEmissione from './pages/RichiesteEmissione';
import DashboardCollaboratori from './pages/DashboardCollaboratori';
import GuidaCollaboratore from './pages/GuidaCollaboratore';
import AniaAllianz from './pages/AniaAllianz';
import MyDashboard from './pages/MyDashboard';
import { AgenziaClienti } from './pages/agenzia/AgenziaClienti';
import { AgenziaPolizze } from './pages/agenzia/AgenziaPolizze';
import { AgenziaCassa } from './pages/agenzia/AgenziaCassa';
import { AgenziaCompagnie } from './pages/agenzia/AgenziaCompagnie';
import { AgenziaReport } from './pages/agenzia/AgenziaReport';
import ImpostazioniAI from './pages/ImpostazioniAI';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Termini from './pages/Termini';
import '@/App.css';

const HomeRedirect = () => {
  const { user } = useAuth();
  const target = user?.ruolo === 'collaboratore' ? '/my-dashboard' : '/dashboard';
  return <Navigate to={target} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/prenota" element={<PrenotaPubblica />} />
          <Route path="/prenota/conferma/:token" element={<PrenotaConferma />} />
          
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<HomeRedirect />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="chat" element={<Chat />} />
            <Route path="reports" element={<Reports />} />
            <Route path="whatsapp" element={<WhatsApp />} />
            <Route path="impostazioni-ai" element={<ImpostazioniAI />} />
            <Route path="emails" element={<Emails />} />
            <Route path="calendario" element={<Calendario />} />
            <Route path="preventivi" element={<Preventivi />} />
            <Route path="finanzia-polizza" element={<FinanziaPolizza />} />
            <Route path="scadenze" element={<Scadenze />} />
            <Route path="consulenze" element={<Consulenze />} />
            <Route path="garanzie" element={<GaranzieComparatore />} />
            <Route path="preventivatore-auto" element={<PreventivatoreAuto />} />
            <Route path="estensione-chrome" element={<EstensionePage />} />
            <Route path="note-ai" element={<NoteAI />} />
            <Route path="prestiti" element={<Prestiti />} />
            <Route path="leads" element={<Leads />} />
            <Route path="sinistri" element={<Sinistri />} />
            <Route path="clienti" element={<Clients />} />
            <Route path="richieste-emissione" element={<RichiesteEmissione />} />
            <Route path="dashboard-collaboratori" element={<DashboardCollaboratori />} />
            <Route path="my-dashboard" element={<MyDashboard />} />
            <Route path="guida" element={<GuidaCollaboratore />} />
            <Route path="ania-allianz" element={<AniaAllianz />} />
            <Route path="agenzia/clienti" element={<AgenziaClienti />} />
            <Route path="agenzia/polizze" element={<AgenziaPolizze />} />
            <Route path="agenzia/cassa" element={<AgenziaCassa />} />
            <Route path="agenzia/compagnie" element={<AgenziaCompagnie />} />
            <Route path="agenzia/report" element={<AgenziaReport />} />
            <Route path="hr" element={<HR />} />
            <Route path="hr/ferie" element={<HRFerie />} />
            <Route path="hr/buste-paga" element={<BustePaga />} />
            <Route path="hr/cud" element={<Navigate to="/hr/buste-paga" replace />} />
            <Route
              path="statistics"
              element={
                <ProtectedRoute adminOnly>
                  <Statistics />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute adminOnly>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="gestione-utenti"
              element={
                <ProtectedRoute adminOnly>
                  <GestioneUtenti />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
